/**
 * Display Labels for UI
 * ✅ SAFE TO CHANGE: Never persisted, frontend-only
 */

import { Gender, AgeGroup, FacialHair, Glasses, Height, Build, SkinTone, Dress, InterestLevel, HairColor, HairStyle, EyeColor } from './attributes.js';

export const GenderLabels = Object.freeze({
  [Gender.MALE]: 'Male',
  [Gender.FEMALE]: 'Female',
  [Gender.OTHER]: 'Other'
});

export const AgeGroupLabels = Object.freeze({
  [AgeGroup.YOUNG]: 'Young (<30)',
  [AgeGroup.THIRTIES]: '30s',
  [AgeGroup.FORTIES]: '40s',
  [AgeGroup.FIFTIES]: '50s',
  [AgeGroup.SIXTIES]: '60s',
  [AgeGroup.SEVENTYPLUS]: '70+'
});

export const FacialHairLabels = Object.freeze({
  [FacialHair.NONE]: 'None',
  [FacialHair.MOUSTACHE]: 'Mustache',
  [FacialHair.BEARD]: 'Beard',
  [FacialHair.GOATEE]: 'Goatee'
});

export const GlassesLabels = Object.freeze({
  [Glasses.YES]: 'Yes',
  [Glasses.NO]: 'No'
});

export const HeightLabels = Object.freeze({
  [Height.SHORT]: 'Short',
  [Height.AVG]: 'Average',
  [Height.TALL]: 'Tall',
  [Height.GIANT]: 'Very Tall'
});

export const BuildLabels = Object.freeze({
  [Build.SKINNY]: 'Very Slim',
  [Build.SLIM]: 'Slim',
  [Build.AVG]: 'Average',
  [Build.TUBBY]: 'Stocky',
  [Build.FAT]: 'Heavy',
  [Build.HUGE]: 'Very Heavy'
});

export const SkinToneLabels = Object.freeze({
  [SkinTone.WHITE]: 'Light',
  [SkinTone.ASIAN]: 'Medium',
  [SkinTone.BLACK]: 'Dark'
});

export const DressLabels = Object.freeze({
  [Dress.FORMAL]: 'Formal',
  [Dress.BUSINESS]: 'Business',
  [Dress.CASUAL]: 'Casual'
});

export const InterestLevelLabels = Object.freeze({
  [InterestLevel.NONE]: 'None',
  [InterestLevel.CRITICAL]: 'Critical',
  [InterestLevel.HIGH]: 'High',
  [InterestLevel.MEDIUM]: 'Medium',
  [InterestLevel.LOW]: 'Low'
});

export const HairColorLabels = Object.freeze({
  [HairColor.BLONDE]: 'Blonde',
  [HairColor.BROWN]: 'Brown',
  [HairColor.BLACK]: 'Black',
  [HairColor.GREY]: 'Gray',
  [HairColor.RED]: 'Red'
});

export const HairStyleLabels = Object.freeze({
  [HairStyle.BALD]: 'Bald',
  [HairStyle.SHORT]: 'Short',
  [HairStyle.BOB]: 'Bob',
  [HairStyle.SHOULDER]: 'Shoulder Length',
  [HairStyle.LONG]: 'Long'
});

export const EyeColorLabels = Object.freeze({
  [EyeColor.GREY]: 'Gray',
  [EyeColor.BLUE]: 'Blue',
  [EyeColor.GREEN]: 'Green',
  [EyeColor.BROWN]: 'Brown',
  [EyeColor.HAZEL]: 'Hazel'
});
